import React from 'react'
import { Skeleton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { isMobile } from 'react-device-detect'
const SuggestionSkeleton = ({ classes, rows = 3 }) => {
  return Array.from({ length: rows }).map((_, rowIndex) => (
    <div key={`skeleton-row-${rowIndex}`} className={classes.skeletonRow}>
      <div className={classes.skeletonLine1}>
        <img
          src="/assets/AI-Assistant-icon.svg"
          width={isMobile ? 16 : 24}
          height={isMobile ? 16 : 24}
          alt="AI Assistant"
          className={classes.skeletonIcon}
        />
        <Skeleton variant="text" width="40%" height={16} />
        <Skeleton
          variant="text"
          width="35%"
          height={16}
          className={classes.skeletonText}
        />
        <Skeleton
          variant="text"
          width="25%"
          height={16}
          className={classes.skeletonText}
        />
      </div>
      <div className={classes.skeletonLine2}>
        <Skeleton variant="text" width="30%" height={16} />
        <Skeleton variant="text" width="25%" height={16} />
        <Skeleton variant="text" width="35%" height={16} />
      </div>
    </div>
  ))
}

export default withStyles(styles)(SuggestionSkeleton)
